import { jsx as r, jsxs as o } from "react/jsx-runtime";
import m from "@material-ui/core/Box";
import v from "@material-ui/core/Button";
import "@material-ui/core/Card";
import "@material-ui/core/CardContent";
import "@material-ui/core/Checkbox";
import "@material-ui/core/CircularProgress";
import "@material-ui/core/Container";
import C from "@material-ui/core/Dialog";
import S from "@material-ui/core/DialogActions";
import T from "@material-ui/core/DialogContent";
import "@material-ui/core/FormControlLabel";
import "@material-ui/core/FormHelperText";
import p from "@material-ui/core/Grid";
import L from "@material-ui/core/IconButton";
import "@material-ui/core/InputBase";
import y from "@material-ui/core/InputLabel";
import E from "@material-ui/core/Link";
import "@material-ui/core/OutlinedInput";
import "@material-ui/core/styles/createStyles";
import $ from "@material-ui/core/styles/makeStyles";
import "@material-ui/core/styles/withStyles";
import "@material-ui/core/styles/withTheme";
import "@material-ui/core/SvgIcon";
import "@material-ui/core/Tab";
import a from "@material-ui/core/Typography";
import j from "@material-ui/icons/Close";
import "@material-ui/icons/Copyright";
import "@material-ui/icons/HowToReg";
import "@material-ui/icons/MailOutline";
import "@material-ui/icons/Payment";
import "@material-ui/icons/Portrait";
import "@material-ui/icons/SmsOutlined";
import "@material-ui/icons/WarningOutlined";
import "@material-ui/lab/Alert";
import "@material-ui/lab/TabContext";
import "@material-ui/lab/TabList";
import "@material-ui/lab/TabPanel";
import { TextField as w } from "@propify-tenant-client/common";
import { api as b, login as q, handleError as D } from "@propify-tenant-client/services";
import W from "classnames";
import { Formik as P, Form as R } from "formik";
import { useState as M } from "react";
import * as l from "yup";
const U = l.object({
  username: l.string().required("Please enter your user name!"),
  password: l.string().required("Please enter your password!")
}), z = $({
  form: {
    "& label.Mui-required .MuiInputLabel-asterisk": {
      color: "red"
    },
    "& .MuiGrid-item": {
      margin: 8
    },
    "&.noMargin .MuiGrid-item": {
      margin: "8px 0"
    },
    "& label": {
      color: "black",
      fontWeight: "500",
      marginBottom: 8,
      fontSize: "0.93rem"
    },
    "& .MuiOutlinedInput-input": {
      height: "0.5em"
    },
    "& .MuiInputBase-input, & .MuiInputBase-multiline": {
      background: "#EBF5FF",
      borderColor: "#CDDFF0"
    },
    "& .messageField textarea": {
      minHeight: 100
    },
    "& .MuiFormHelperText-root.Mui-error": {
      marginBottom: -5
    }
  },
  errorMessage: {
    color: "red"
  }
}), Lr = ({ open: x, lead: i, onClose: u, redirectLink: F, onLoginSubmit: I }) => {
  const d = z(), [c, h] = M(), [B, g] = M(!1), k = (t) => {
    I(), h(void 0), g(!0), q(t).then((e) => {
      const n = `${b.BASE_URL}/user/login?accessToken=${e.auth}`;
      window.location.href = `${n}&redirect=${encodeURIComponent(F)}`;
    }).catch((e) => {
      var s;
      D(e, { displayToast: !1 });
      const n = ((s = e == null ? void 0 : e.response) == null ? void 0 : s.status) === 401 ? "Invalid username or password" : "There has been an error while trying to log in";
      h(n);
    }).finally(() => {
      g(!1);
    });
  };
  return /* @__PURE__ */ r(
    P,
    {
      enableReinitialize: !0,
      validationSchema: U,
      initialValues: {
        username: (i == null ? void 0 : i.email) ?? "",
        password: ""
      },
      onSubmit: k,
      children: ({ touched: t, errors: e, values: n, submitForm: s, handleChange: f }) => /* @__PURE__ */ r(R, { children: /* @__PURE__ */ o(C, { open: x, fullWidth: !0, maxWidth: "sm", onClose: u, children: [
        /* @__PURE__ */ o(T, { children: [
          /* @__PURE__ */ o(
            m,
            {
              style: { display: "flex", justifyContent: "space-between", alignItems: "center" },
              children: [
                /* @__PURE__ */ r(a, { variant: "h6", children: "Thank you for your interest in this property!" }),
                /* @__PURE__ */ r(L, { onClick: u, children: /* @__PURE__ */ r(j, {}) })
              ]
            }
          ),
          /* @__PURE__ */ r(m, { mt: 2, children: /* @__PURE__ */ r(a, { variant: "caption", style: { marginTop: 17 }, children: "Sign in using your existing account by entering your password below." }) }),
          /* @__PURE__ */ o(
            p,
            {
              container: !0,
              spacing: 2,
              className: W(d.form, "enable-default-input-background", "noMargin"),
              children: [
                /* @__PURE__ */ o(p, { item: !0, xs: 6, children: [
                  /* @__PURE__ */ r(y, { htmlFor: "username", required: !0, children: "Email" }),
                  /* @__PURE__ */ r(
                    w,
                    {
                      name: "username",
                      value: n.username,
                      variant: "outlined",
                      fullWidth: !0,
                      onChange: f,
                      inputProps: {
                        autoCapitalize: "off"
                      },
                      helperText: t.username ? e.username : "",
                      error: t.username && !!e.username,
                      autoFocus: !0
                    }
                  )
                ] }),
                /* @__PURE__ */ o(p, { item: !0, xs: 6, children: [
                  /* @__PURE__ */ r(y, { htmlFor: "password", required: !0, children: "Password" }),
                  /* @__PURE__ */ r(
                    w,
                    {
                      id: "password",
                      name: "password",
                      onChange: f,
                      value: n.password,
                      variant: "outlined",
                      type: "password",
                      fullWidth: !0,
                      helperText: t.password ? e.password : "",
                      error: t.password && !!e.password
                    }
                  )
                ] })
              ]
            }
          ),
          c && /* @__PURE__ */ r(m, { my: 2, children: /* @__PURE__ */ r(a, { className: d.errorMessage, variant: "body2", children: c }) })
        ] }),
        /* @__PURE__ */ o(S, { style: { justifyContent: "space-between" }, children: [
          /* @__PURE__ */ r(a, { children: /* @__PURE__ */ r(
            E,
            {
              href: `${b.BASE_URL}/user/password-reset?redirect=/showings/schedule?unitId=${i == null ? void 0 : i.unitId}`,
              children: "Forgot your password?"
            }
          ) }),
          /* @__PURE__ */ r(v, { disabled: B, variant: "contained", color: "primary", onClick: s, children: "Sign In" })
        ] })
      ] }) })
    }
  );
};
export {
  Lr as default
};
//# sourceMappingURL=LoginModal.js.map
